import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { EstatusJSON } from "../../models/EstatusJSON";
import { IApiBase } from "./Interface/IApiBase.interface";
import { FilterRequest } from "../../models/Filter/FilterRequest";
import { CatalogPaginationRequest } from "../../models/CatalogPagination/CatalogPaginationRequest";

@Injectable({
  providedIn: "root",
})
export class UserLogsAPIService implements IApiBase{
  
  configUrl: string;
  public Result;
  estatus: EstatusJSON;
  constructor(private http: HttpClient) {
    this.configUrl = environment.host;
    this.estatus = new EstatusJSON();
  }
  insert() {
    throw new Error("Method not implemented.");
  }
  update(datos: any) {
    throw new Error("Method not implemented.");
  }
  getFilterValues(request: FilterRequest[]) {
    throw new Error("Method not implemented.");
  }

  getFilterCount(dato): any {
    return this.http.get<EstatusJSON>(this.configUrl + "/api/UserLog/GetFilterCount?dato="+dato, {});
  }
  getFilter(filtro): any {
    return this.http.get<EstatusJSON>(this.configUrl + "/api/UserLog/GetFiltered?dato="+filtro, {});
  }

  //se van a cambiar al nuevo tipo de catalogo
  getActivePage(page, dato): any {
    return this.http.get<EstatusJSON>(this.configUrl + "/api/UserLog/GetActivePage?page="+page+"&&dato="+dato, {});
  }

  getActiveCount(dato): any {
    return this.http.get<EstatusJSON>(this.configUrl + "/api/UserLog/GetActiveCount?dato="+dato, {});
  }

  getFilterPage(page, dato): any {
    return this.http.get<EstatusJSON>(this.configUrl + "/api/UserLog/GetFilterPage?page="+page+"&&dato="+dato, {});
  }



  getCount(pageRequest: CatalogPaginationRequest) {
    return this.http.post<EstatusJSON>(this.configUrl + "/api/UserLog/GetCount", pageRequest);
  }

  getPage(pageRequest: CatalogPaginationRequest) {
    return this.http.post<EstatusJSON>(this.configUrl + "/api/UserLog/GetPage", pageRequest);
  }

  

  delete(UserId): any{
    console.log("no hay delete");
  }
  
}
